var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMixcloud = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM7.61841 14.6739H8.65562V9H6.60403L5.46084 14.4093H5.19525L4.05156 9H2V14.6739H3.03722V9.94106L2.85238 9.26469H3.17912L4.37834 14.6739H6.28522L7.47694 9.26469H7.81166L7.61841 9.94106V14.6739ZM16.3261 14.6455L19.0143 12.7059H19.3038L22 14.6455V13.4547L19.7146 11.8368L22 10.2193V9.028L19.3038 10.976H19.0143L16.3261 9.028V10.2193L18.604 11.8368L16.3261 13.4542V14.6455ZM9.75353 12.3535H15.4424V11.3205H9.75353V12.3535Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMixcloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mixcloud.ab30e129.svg";
export { ForwardRef as ReactComponent };